export default __webpack_public_path__ + "static/media/mirolyub_l.6499e7bc.jpg";